import { Badge, Box, Flex, IconButton, Input } from '@chakra-ui/react';
import { memo, useEffect, useState } from 'react';
import { HiMinus, HiPlus, HiTrash } from 'react-icons/hi2';

const QtyActionBtn = ({ icon, onClick, isDisabled, variant = 'outline', colorScheme = 'gray', ...props }) => <IconButton icon={icon} size='sm' onClick={onClick} isDisabled={isDisabled} variant={variant} colorScheme={colorScheme} _disabled={{ opacity: 0.1, cursor: 'not-allowed' }} {...props} />;

const ProductItemQtyPackage = ({ showControlQty = true, showInputQty = true, max = 10, min = 0, defaultValue = 0, isDisabled = false, canDelete = false, size = 'sm', onChangeQty = () => {}, onDeleteItem = () => {}, misc = {} }) => {
    const [value, setValue] = useState(defaultValue);
    const { isMultiSelection, remainingQuota = 0, isDefaultMenu = false } = misc;

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    // LOGIKA DECREMENT:
    // Jika isDefaultMenu, kita bisa set min lebih ketat jika diperlukan.
    const isDisableDecrement = isDisabled || value <= min;

    // LOGIKA INCREMENT:
    const isDisableIncrement = isDisabled || (isMultiSelection ? remainingQuota <= 0 : value >= max);

    const handleUpdate = (step) => {
        const nextValue = value + step;
        if (nextValue >= min && nextValue <= max) {
            if (step > 0 && isMultiSelection && remainingQuota <= 0) return;
            setValue(nextValue);
            onChangeQty(nextValue);
        }
    };

    return (
        <Flex w='full' alignItems='center' justifyContent='space-between' gap={4}>
            <Box w='full'>
                <Flex w='full' alignItems='center' justifyContent='end' gap={2}>
                    {/* Badge DEFAULT jika menu wajib */}
                    {isDefaultMenu && value > 0 && (
                        <Badge colorScheme='blue' variant='subtle' fontSize='2xs'>
                            DEFAULT
                        </Badge>
                    )}

                    {showControlQty && <QtyActionBtn icon={<HiMinus />} isDisabled={isDisableDecrement} colorScheme='red' onClick={() => handleUpdate(-1)} size={size} />}

                    {showInputQty && (
                        <Input
                            readOnly
                            type='number'
                            w='75px'
                            size={size}
                            rounded='md'
                            variant='filled'
                            colorScheme='secondary'
                            value={value}
                            textAlign='center'
                            _disabled={{ color: 'black', fontWeight: 'bold' }}
                            border={isDefaultMenu && value === 0 ? '1px solid red' : 'none'} // Highlight jika kosong
                        />
                    )}

                    {showControlQty && <QtyActionBtn icon={<HiPlus />} isDisabled={isDisableIncrement} variant='solid' colorScheme='primary' onClick={() => handleUpdate(1)} size={size} />}
                </Flex>
            </Box>

            {/* Tombol Delete disembunyikan jika menu default/wajib */}
            {canDelete && !isDefaultMenu && (
                <Box ml={2}>
                    <IconButton icon={<HiTrash />} size='sm' variant='outline' colorScheme='red' onClick={onDeleteItem} />
                </Box>
            )}
        </Flex>
    );
};

export default memo(ProductItemQtyPackage);
